import classNames from 'classnames'
import * as Icon from 'react-feather'
import React from 'react'
import { Home } from 'react-feather'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import {
  Nav,
  NavItem,
  NavLink as NavLinkReactstrap,
  TabContent,
  TabPane,
} from 'reactstrap'
import styled from 'styled-components'
import Breadcrumb from '~/components/Breadcrumb'
import { Col, Show } from '~/components/commons'
import EditVariablesForm from './components/EditVariablesForm'
import { ReactComponent as ByoGGLogo } from '../../../assets/img/svg/byogg.svg'
import EditMicroSiteForm from './components/EditMicroSiteForm'
import EditTemplatesForm from './components/EditTemplatesForm'
import { useQueryParamsReplace } from '~/hooks/useQueryParams'
import { NumberParam, StringParam, withDefault } from 'use-query-params'
import EditNPSForm from './components/EditNPSForm'
import ExchangeIcon from '~/components/commons/ExchangeIcon'
import IntegrationList from './components/IntegrationList'
import { IntegrationsProvider } from './contexts/integrations.context'
import { SearchParamsHandlerProvider } from '~/contexts/FilterContext'
import { useSelector } from 'react-redux'

const TAB_INDEX_TO_PARAMS = {
  1: 'reviews',
  2: 'questions',
}

const breadcrumbPaths = [
  {
    render: () => (
      <Link className="d-flex align-items-center" to="/">
        <Home size={20} />
      </Link>
    ),
  },
  {
    render: () => (
      <Link className="d-flex align-items-center" to="/locations/overview">
        <FormattedMessage id="Account Settings" />
      </Link>
    ),
  },
]

const ShowIntegration = ({ children }) => {
  const accountWithAccessToIntegration =
    process.env.REACT_APP_INTEGRATIONS_ACCOUNT
  const USER_ROLE = useSelector(state => state.user?.profile?.role)
  const ACCOUNT_ID = useSelector(state => state.user?.profile?.account?.id)
  return (
    <Show
      condition={
        ACCOUNT_ID === accountWithAccessToIntegration || USER_ROLE >= 3
      }
    >
      {children}
    </Show>
  )
}

function AccountSettings() {
  const [queryParams, setQueryParams] = useQueryParamsReplace({
    tab: StringParam,
    t: StringParam,
  })
  const [activeTab, setActiveTab] = React.useState('1')
  const [templateTab, setTemplateTab] = React.useState('1')

  function handleTabChange(tab) {
    setTemplateTab(tab)
    setQueryParams({ tab: TAB_INDEX_TO_PARAMS[tab] })
  }

  React.useEffect(() => {
    const tab = queryParams.tab
    setTemplateTab(tab === 'questions' ? '2' : '1')

    const pageTab = queryParams.t
    if (pageTab) {
      setActiveTab(pageTab)
    }
  }, [queryParams])

  return (
    <Col>
      <Breadcrumb paths={breadcrumbPaths} />

      <div
        className="nav-vertical d-flex flex-column flex-md-row w-100"
        id="scrool-to-top"
      >
        <Nav
          tabs
          className="nav-left mt-1 "
          style={{ minWidth: '150px', boxShadow: 'none' }}
        >
          <NavItem>
            <NavLinkPane
              className={classNames({
                active: activeTab === '1',
              })}
              onClick={() => setActiveTab('1')}
            >
              <Icon.FileText className="mr-1" />
              <FormattedMessage id="Templates" />
            </NavLinkPane>
          </NavItem>
          <NavItem>
            <NavLinkPane
              className={classNames({
                active: activeTab === '2',
              })}
              onClick={() => setActiveTab('2')}
            >
              <Icon.Hash className="mr-1" />
              <FormattedMessage id="Variables" />
            </NavLinkPane>
          </NavItem>
          <NavItem>
            <NavLinkPane
              className={classNames({
                active: activeTab === '3',
              })}
              onClick={() => setActiveTab('3')}
            >
              <ByoGGLogo className="mr-1" />
              <FormattedMessage id="Micro Site" />
            </NavLinkPane>
          </NavItem>
          <NavItem>
            <NavLinkPane
              className={classNames({
                active: activeTab === '4',
              })}
              onClick={() => setActiveTab('4')}
            >
              <Icon.Smile className="mr-1" />
              <FormattedMessage id="NPS" />
            </NavLinkPane>
          </NavItem>
          <ShowIntegration>
            <NavItem>
              <NavLinkPane
                className={classNames({
                  active: activeTab === '5',
                })}
                onClick={() => setActiveTab('5')}
              >
                <ExchangeIcon className="mr-1" />
                <FormattedMessage id="Integrations" />
              </NavLinkPane>
            </NavItem>
          </ShowIntegration>
        </Nav>
        <TabContent activeTab={activeTab} className="mt-1 w-100">
          <TabPane tabId="1" className="bg-transparent p-1 m--1">
            <EditTemplatesForm
              templateTab={templateTab}
              setTemplateTab={handleTabChange}
            />
          </TabPane>
          <TabPane tabId="2" className="bg-transparent">
            <EditVariablesForm />
          </TabPane>
          <TabPane tabId="3" className="bg-transparent">
            <EditMicroSiteForm />
          </TabPane>
          <TabPane tabId="4" className="bg-transparent">
            <EditNPSForm />
          </TabPane>
          <ShowIntegration>
            <TabPane tabId="5" className="bg-transparent p-1 m--1">
              <SearchParamsHandlerProvider
                queryParams={{
                  'integration-page': withDefault(NumberParam, 1),
                  'integration-tab': withDefault(StringParam, 'all'),
                  'integration-limit': withDefault(NumberParam, 10),
                }}
              >
                <IntegrationsProvider>
                  <IntegrationList />
                </IntegrationsProvider>
              </SearchParamsHandlerProvider>
            </TabPane>
          </ShowIntegration>
        </TabContent>
      </div>
    </Col>
  )
}

const NavLinkPane = styled(NavLinkReactstrap)`
  color: #626262 !important;

  &.active {
    font-weight: 600;
    color: #7367f0 !important;
    &::after {
      left: auto !important;
      right: 0px !important;
      top: 1.3rem !important;
    }
  }
`

export default AccountSettings
